import {
  Box,
  Button,
  Card,
  Chip,

  Divider,
  Drawer,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosInstance";
import { SA_ORGANIZATIONS_LIST } from "../shared/constants/apiEndpoints";
import AgGridTable from "../components/table/AgGridTable";
import InviteOrgTableDrawer from "../components/drawer/InviteOrgTableDrawer";
import InviteOrgDrawer from "../components/drawer/InviteOrgDrawer";
import CancelIcon from "@mui/icons-material/Cancel";
import NoData_img1 from "../assets/baseVersion/Nodata.svg";
import InviteSuperUser from "../components/drawer/InviteSuperUser";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditUser from "./EditUser";
import { makeEncryptedApiCall } from "../utils/encryptionUtils";
import { toast } from "react-toastify";
import UserRight_img from "../assets/baseVersion/UserTick_img.svg";
import UserCross_img from "../assets/baseVersion/UserCross_img.svg";
import SkeletonLoader from "../components/skeleton_loader";

const User = () => {
  const [isTableRowClick, setIsTableRowClick] = useState(false);
  const [orgData, setOrgData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isSelectedRowId, setIsSelectedRow] = useState<any>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEditUser, setIsEditUser] = useState(false);
  const [editUserIdData, setEditUserData] = useState<string | null>(null);

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const InviteTable = () => {
    setLoading(true);
    axiosInstance
      .get("authentication/sa-list-users")
      .then((res) => {
        const users = res.data?.data?.users || [];

        const transformedData = users.map((user: any) => ({
          user_name: user.name || "-", // Adapt as needed
          email: user.email || "-",
          status: user.status,
          id: user.user_id,
          onboarding_date: user.onboarding_date,
          first_name: user?.first_name,
          last_name: user?.last_name,
          contact: user?.phone_number,
          permissions: user.permissions?.length ? user.permissions : ["-"],
        }));

        setTableData(users);
        setOrgData(transformedData);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        setOrgData([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    InviteTable();
  }, []);

  const handleReInvite = async (userId: string) => {
    // handleClose();
    // console.log("Delete clicked for", props.data);

    try {
      const response = await makeEncryptedApiCall(
        "/authentication/sa-reinvite-user",
        {
          user_id: userId,
        }
      );
      toast.success(response?.data?.message);

      console.log("Deactivation successful:", response.data);
    } catch (error: any) {
      console.error("Error during deactivation:", error);
      toast.error(error?.response?.data?.message);
    }
  };

  const KebabMenuCellRenderer = (props: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleEdit = () => {
      handleClose();
      console.log("Edit clicked for", props.data);
      setIsEditUser(true);
      setEditUserData(props?.data);
    };

    const handleDeactivate = async () => {
      handleClose();
      console.log("Delete clicked for", props.data);

      try {
        const response = await makeEncryptedApiCall(
          "/authentication/sa-deactivate-user",
          {
            user_id: props.data.id,
          }
        );
        toast.success(response?.data?.message);

        console.log("Deactivation successful:", response.data);
      } catch (error: any) {
        console.error("Error during deactivation:", error);
        toast.error(error?.response?.data?.message);
      }
    };

    return (
      <>
        <IconButton size="small" onClick={handleClick}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
          {props.data.status !== "deactivated" && (
            <MenuItem onClick={handleDeactivate}>Deactivate</MenuItem>
          )}
          {/* <MenuItem onClick={handleReInvite}>Re Invite</MenuItem> */}
        </Menu>

        <Drawer
          anchor="right"
          open={isEditUser}
          onClose={() => setIsEditUser(false)}
          hideBackdrop // remove MUI's backdrop entirely
          sx={{
            "& .MuiDrawer-paper": {
              width: "45%",
              overflow: "auto",
              scrollbarWidth: "thin",
              bgcolor: isDarkMode ? "#1E1E1E" : "#fff",
              boxShadow: "none",
            },
          }}
        >
          <Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 13,
                bgcolor: isDarkMode ? "#1E1E1E" : "#fff",
                minHeight: 64,
                px: 2,
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", fontSize: "16px" }}
              >
                Edit Super User
              </Typography>
              <IconButton onClick={() => setIsEditUser(false)}>
                <CancelIcon sx={{ color: "#A6A5B6" }} />
              </IconButton>
            </Box>
            <Divider />
            <EditUser
              editUserIdData={editUserIdData}
              onCloseDrawer={() => setIsEditUser(false)}
              onUserUpdate={() => {
                InviteTable();
                setIsEditUser(false);
              }}
            />
          </Box>
        </Drawer>
      </>
    );
  };

  // }, []);

  const userColumnsDefs = [

{
  headerName: "Name",
  field: "user_name",
  filter: false,
  minWidth: 200,
 cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },  cellRenderer: (params: any) => {
    return (
      <Tooltip
        title={params.value || ""}
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: "#fff",
              color: "#000",
              fontSize: "14px",
              boxShadow: 2,
            },
          },
          arrow: {
            sx: {
              color: "#fff",
            },
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
        >
          {params.value}
        </Typography>
      </Tooltip>
    );
  },
},

    {
      headerName: "Email",
      field: "email",
      minWidth: 230,

      cellRenderer: (params: any) => {
        return (
          <Tooltip title={params.value || ""} arrow slotProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#fff",
                              color: "#000",
                              fontSize: "14px",
                              // border: "1px solid #ccc",
                              boxShadow: 1,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#fff",
                            },
                          },
                        }}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      },
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: "180",
      cellRenderer: (params: any) => (
        <Chip
          label={
            params.value === "invited"
              ? "Invited"
              : params.value === "invite_expired"
                ? "Invite Expired"
                : params.value.charAt(0).toUpperCase() + params.value.slice(1)
          }
          size="small"
          variant="outlined"
          sx={{
            fontWeight: "bold",
            fontSize: "13px",
            borderRadius: "6px",
            px: 1.5,
            py: 0.5,
            textTransform: "capitalize",
            borderWidth: "1.5px",
            ...(params?.value?.toLowerCase() === "active" && {
              color: "#00A61B",
              borderColor: "#00A61B",
              backgroundColor: "#00A61B1A",
            }),
            ...(params?.value?.toLowerCase() === "deactivated" && {
              color: "#7C79A3",
              borderColor: "#7C79A3",
              backgroundColor: "#7C79A31A",
            }),
            ...(params?.value?.toLowerCase() === "invite_expired" && {
              color: "#F53B3B",
              borderColor: "#F53B3B",
              backgroundColor: "#F53B3B1A",
            }),
          }}
        />
      ),
    },
    {
      headerName: "Onboarding date",
      field: "onboarding_date",
      minWidth: "170",
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Modify Licenses",
      field: "permissions",
      minWidth: "155",

      cellRenderer: (params: any) => {
        console.log(params?.value);

        const requiredPermissions = [
          "View Organizations",
          "Invite Organizations",
          "Modify Licenses",
        ];

        const hasPermission =
          Array.isArray(params.value) &&
          requiredPermissions.every((perm) => params.value.includes(perm));

        return (
          <img
            src={hasPermission ? UserRight_img : UserCross_img}
            alt="Modify Licenses"
            style={{ width: 20, height: 20, cursor: "pointer" }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      headerName: "View Organizations",
      field: "permissions",
      minWidth: "170",

      cellRenderer: (params: any) => (
        <img
          src={UserRight_img}
          alt="View Organizations"
          style={{ width: 20, height: 20 }}
        />
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      headerName: "Invite Organization",
      field: "permissions",
      minWidth: "150",
      miaWidth: "170",

      cellRenderer: (params: any) => {
        console.log(params?.value);

        const requiredPermissions = [
          "View Organizations",
          "Invite Organizations",
        ];

        const hasPermission =
          Array.isArray(params.value) &&
          requiredPermissions.every((perm) => params.value.includes(perm));

        return (
          <img
            src={hasPermission ? UserRight_img : UserCross_img}
            alt="Modify Licenses"
            style={{ width: 20, height: 20, cursor: "pointer" }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      headerName: "",
      field: "status",
      filter: false,
      minWidth: 70,

      cellRenderer: (params: any) => {
        if (params.value === "invite_expired") {
          return (
            <Typography
              onClick={() => handleReInvite(params.data.id)}
              variant="body2"
              sx={{
                color: isDarkMode ? "#fff" : "#3A2ADA",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Re-Invite
            </Typography>
          );
        }
        return null;
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },

    {
      headerName: "",
      field: "",
      cellRenderer: KebabMenuCellRenderer,
      minWidth: 100,
      sortable: false,
      filter: false,
    },
  ];

  const handleOnRowClick = (row: any) => {
    // setIsTableRowClick(true);
    setIsSelectedRow(row.id);
  };

   const handleInviteSuccess = () => {
    InviteTable();
    setIsDrawerOpen(false);
  };


  return (
    <>
      <Box sx={{ width: "100%", height: "100%" }}>
        <Card
          variant="outlined"
          sx={{
            height: "calc(100vh - 103px)",
            borderRadius: 3,
            width: "100%",
          }}
        >
          {loading ? (
            <Box
              sx={{
                width: "100%",
                height: "calc(88vh - 90px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 40)}
                styles={{ height: 30, width: "100%" }}
              />
            </Box>
          ) : tableData?.length > 0 ? (
            <AgGridTable
              columnDefs={userColumnsDefs}
              data={orgData}
              showSearch
              isRowSelectable
              height={"calc(91.5vh - 90px)"}
              onRowClick={handleOnRowClick}
              isLoading={loading}
              onInviteSuccess={handleInviteSuccess}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100vh",
                width: "100vw",
                position: "fixed",
                top: 0,
                left: 0,
                bgcolor: "background.default",
              }}
            >
              <img
                src={NoData_img1}
                alt="No Data"
                style={{ width: 300, marginBottom: 16 }}
              />
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", mt: 2, mb: 1 }}
              >
                Welcome to Spark Super Admin!
              </Typography>
              <Typography
                variant="body2"
                align="center"
                sx={{
                  fontSize: "13px",
                  mb: 3,
                  color: isDarkMode ? "white" : "gray600",
                  fontWeight: 600,
                }}
              >
                Let’s get started by inviting your first user by
                <br />
                clicking the button below.
              </Typography>
              <Button
                variant="contained"
                onClick={() => setIsDrawerOpen(true)}
                style={{ padding: "8px" }}
              >
                Invite Super User
              </Button>

              <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                sx={{
                  "& .MuiDrawer-paper": {
                    width: "45%",
                    overflow: "auto",
                    scrollbarWidth: "thin",
                  },
                }}
              >
                <Box>
                  <Divider />
                  <InviteSuperUser onInviteSuccess={handleInviteSuccess} />
                </Box>
              </Drawer>
            </Box>
          )}
        </Card>
      </Box>
    </>

  );
};

export default User;
